<template>
    <div>
        <base-nav
            :transparent="true"
            class="auth-navbar fixed-top"
            menu-classes="justify-content-end"
            type="white"
            v-model="showMenu"
        >
            <div class="navbar-wrapper" slot="brand">
                <a class="navbar-brand" href="https://hoptone.com" v-if="title">
                    Powered by
                    <img class="img img-responsive" style="max-width: 150px;"
                         src="/img/Hoptone_Logo_Horizontal.png" alt="Hoptone logo">
                </a>
            </div>

            <ul class="navbar-nav">
                <router-link class="nav-item" tag="li" to="/login">
                    <a class="nav-link">
                        <font-awesome-icon :icon="['fal','sign-in']"></font-awesome-icon>
                        Login
                    </a>
                </router-link>

            </ul>
        </base-nav>

        <div class="wrapper wrapper-full-page">
            <div :class="pageClass" class="full-page">
                <div class="content">
                    <zoom-center-transition
                        :duration="pageTransitionDuration"
                        mode="out-in"
                    >
                        <setup></setup>
                    </zoom-center-transition>
                </div>
                <footer class="footer">
                    <div class="container-fluid">
                        <nav>
                            <ul class="nav">
                                <li class="nav-item">
                                    <a
                                        class="nav-link"
                                        href="https://hoptone.com"
                                        rel="noopener"
                                        target="_blank"
                                    >
                                        <img class="img img-responsive" style="max-width: 150px;"
                                             src="/img/Hoptone_Logo_Horizontal.png" alt="Hoptone logo">

                                    </a>
                                </li>
                            </ul>
                        </nav>
                        <div class="copyright">
                            &copy; {{ year }}, made with
                            <font-awesome-icon :icon="['fal','heart']"></font-awesome-icon>
                            by
                            <a href="https://qanyon.com" target="_blank">Qanyon</a>
                            for a better web.
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {BaseNav} from 'src/components';
    import {ZoomCenterTransition} from 'vue2-transitions';
    import Setup from "./setup";

    export default {
        components: {
            Setup,
            BaseNav,
            ZoomCenterTransition
        },
        props: {
            backgroundColor: {
                type: String,
                default: 'black'
            }
        },
        data() {
            return {
                showMenu: false,
                menuTransitionDuration: 250,
                pageTransitionDuration: 200,
                year: new Date().getFullYear(),
                pageClass: 'login-page'
            };
        },
        computed: {
            title() {
                return `${this.$route.name} Page`;
            }
        },
        methods: {
            toggleNavbar() {
                document.body.classList.toggle('nav-open');
                this.showMenu = !this.showMenu;
            },
            closeMenu() {
                document.body.classList.remove('nav-open');
                this.showMenu = false;
            },
            setPageClass() {
                this.pageClass = `${this.$route.name}-page`.toLowerCase();
            }
        },
        beforeDestroy() {
            this.closeMenu();
        },
        beforeRouteUpdate(to, from, next) {
            // Close the mobile menu first then transition to next page
            if (this.showMenu) {
                this.closeMenu();
                setTimeout(() => {
                    next();
                }, this.menuTransitionDuration);
            } else {
                next();
            }
        },
        mounted() {
            this.setPageClass();
        },
        watch: {
            $route() {
                this.setPageClass();
            }
        }
    };
</script>
<style lang="scss">
    .navbar.auth-navbar {
        top: 0;
    }

    $scaleSize: 0.8;
    @keyframes zoomIn8 {
        from {
            opacity: 0;
            transform: scale3d($scaleSize, $scaleSize, $scaleSize);
        }
        100% {
            opacity: 1;
        }
    }

    .wrapper-full-page .zoomIn {
        animation-name: zoomIn8;
    }

    @keyframes zoomOut8 {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            transform: scale3d($scaleSize, $scaleSize, $scaleSize);
        }
    }

    .wrapper-full-page .zoomOut {
        animation-name: zoomOut8;
    }
</style>
